import { render, staticRenderFns } from "./PortfolioArchives.vue?vue&type=template&id=aa33e6e8"
import script from "@/views/Users/Student/Progress/PortfolioArchives.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Progress/PortfolioArchives.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/Progress/progress-cito-results.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports